import React from 'react';
import Table from '../../../components/Table';

const NonUsersTable = ({ items }) => {
  const columns = [
    {
      label: 'Email',
      field: 'email',
      textAlign: 'left',
      fontWeight: 'semibold',
      width: '40%',
    },
  ];

  const reconstructorFn = (user) => {
    const { email } = user;

    return {
      email,
    };
  };

  return (
    <div>
      <div className="mb-4 ml-10 flex items-center">
        <h2 className="font-semibold">Non Users</h2>
      </div>

      {!items?.isLoading && (
        <Table
          id="non_users"
          data={items}
          columns={columns}
          reconstructorFn={reconstructorFn}
          hasCheckbox={false}
        />
      )}
    </div>
  );
};

export default NonUsersTable;
